<template>
  <div id="cardConfirmation">
    <Loader/>
  </div>
</template>

<script>
import Http from '@/services/Http';
import Loader from '@/components/otherElements/Loader';

export default {
  name: 'CardConfirmation',
  components: { Loader },
  created() {
    if (!this.$route.query.id || !this.$route.query.token) {
      this.$router.push({ name: 'cabinet' });
      return;
    }

    Http.confirmationCard({
      cardId: this.$route.query.id,
      token: this.$route.query.token,
    })
      .then(() => {
        this.$alert({
          type: 'success',
          text: this.$t('card.change.successful'),
        });
      })
      .catch(() => {
        this.$alert({
          type: 'warning',
          text: this.$t('card.change.failed'),
        });
      })
      .finally(() => {
        this.$router.push({ name: 'payout' });
      });
  },
};
</script>
